import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

const InProgressServiceCard = ({isUdFlow}) => {
  return (
    <Card style={{background: isUdFlow ? '#0E7693': '#1F4A7C'}}>
      <CardContent style={{textAlign: 'center', color: '#fff'}}>
        <Typography variant="h6">
          Thanks for Visiting
        </Typography>
        <Typography variant="body1">
          Work is in progress for this service. We will notify you once this service is ready to use.
        </Typography>
      </CardContent>
    </Card>
  );
}

export default InProgressServiceCard;
